<div class="mb-3">
    <label class="form-label ng-star-inserted">{{to.label}}</label>
    <input [value]="value" class="form-control ng-untouched ng-pristine ng-star-inserted" type="text" [readOnly]="to.readonly" disabled="" />
</div>